import { render, staticRenderFns } from "./FeeStructureInstalments.vue?vue&type=template&id=39647768"
import script from "./FeeStructureInstalments.vue?vue&type=script&lang=js"
export * from "./FeeStructureInstalments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports